import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { APP_CONFIG, Settings } from 'src/app/config/settings';
import { combine } from 'src/app/shared/utilities/route';
import { MarginExpenseType } from '../models/margin-expense-type.model';
import { FacilityExpenseCaps } from 'src/app/shared/models/facility-expense-caps.model';

@Injectable({ providedIn: 'root' })
export class MarginExpensesService {
    private readonly coreApiPath: string;

    constructor(
        private readonly http: HttpClient,
        @Inject(APP_CONFIG) settings: Settings
    ) {
        this.coreApiPath = combine(settings.coreAPIUrl, 'ayanova');
    }

    getMarginExpensesTypes(): Observable<MarginExpenseType[]> {
        const url = combine(this.coreApiPath, 'locums/margins/expenses/types');
        return this.http.get<MarginExpenseType[]>(url);
    }

    getExpenseCapsByFacilityId(facilityId: number): Observable<FacilityExpenseCaps[]> {
        const url = combine(this.coreApiPath, `locums/margins/expenses/facilities/${facilityId}/expense-caps`);
        return this.http.get<FacilityExpenseCaps[]>(url).pipe(
            map((caps) =>
                caps.map((cap) => ({
                    ...cap,
                    frequency: this.normalizeFrequency(cap.frequency)
                }))
            )
        );
    }

    private normalizeFrequency(frequency: string): string {
        if (!frequency) {
            return '';
        }

        frequency = frequency.toLowerCase();

        if (frequency.startsWith('per ')) {
            return frequency;
        }
        return 'per ' + frequency;
    }
}
